import React, { useEffect } from "react";
import { Button, Form, Input, Space } from "antd";
import "./sp_cop.css";
import { DataTypeCOP } from "../../components/hoc_supplier_master";

interface SpCopProps {
    onCancel?: () => void;
    onSubmit?: (values: any) => void;
    initialData?: DataTypeCOP | null;
    isEditMode?: boolean;
}

const SpCop: React.FC<SpCopProps> = ({
    onCancel,
    onSubmit,
    initialData,
    isEditMode
}) => {
    const [form] = Form.useForm();
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
        padding: '20px 0 0 0'
    };

    useEffect(() => {
        if (isEditMode && initialData) {
            form.setFieldsValue({
                contact_name: initialData.contact_name,
                devision: initialData.devision,
                job_title: initialData.job_title,
                phone_no: initialData.phone_no,
            });
        } else {
            form.resetFields();
        }
    }, [initialData, isEditMode, form]);

    const onFinish = (values: any) => {
        if (onSubmit) {
            onSubmit(values);
        }
        form.resetFields();
    };

    return (

        <div id="iau9" style={transformStyle}>
            <div className="gjs-grid-row" id="inkgn">
                <div className="gjs-grid-column" id="ivlxf">
                    <Form
                        form={form}
                        onFinish={onFinish}
                        layout="horizontal"
                        style={{ maxWidth: 370 }}
                        labelCol={{ style: { width: '140px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '220px' } }}
                        className="custom-info-purchase-request"
                    >
                        <Form.Item
                            label="Contact Name"
                            name="contact_name"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Devision"
                            name="devision"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Job Title"
                            name="job_title"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Phone No"
                            name="phone_no"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Status"
                            name="status"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" disabled/>
                        </Form.Item>
                        <Form.Item>
                            <Space
                                style={{
                                    paddingTop: "20px",
                                }}
                            >
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{
                                        height: "40px",
                                        width: "120px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    icon={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            style={{ width: "22px", height: "22px" }}
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    }
                                >
                                    {isEditMode ? 'Update' : 'Submit'}
                                </Button>

                                <Button
                                    type="primary"
                                    onClick={onCancel}
                                    style={{
                                        height: "40px",
                                        width: "120px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: "red",
                                        color: "white",
                                        border: "none",
                                    }}
                                    icon={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            style={{ width: "22px", height: "22px" }}
                                        >
                                            <path fillRule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clipRule="evenodd" />
                                        </svg>
                                    }
                                >
                                    Cancel
                                </Button>
                            </Space>
                        </Form.Item>
                    </Form>
                </div>
            </div>

        </div>
    );
};

export default SpCop;
